import { Injectable } from '@angular/core';
import { ApiResponse, Order, OrderApi } from '../interfaces/order.interface';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfiguration } from '../app.config';
import { AuthService } from './auth-service.service';
import { ApiHomologationService } from './api-homologation.service';
import { MyAccountService } from './my-account.service';
import { environment } from '../../environments/environment';
import { NotificationService } from './notification.service';
import { OrderProductDetailService } from './order-product-detail.service';


@Injectable({
  providedIn: 'root'
})
export class HomeService {

  orderNumber: string = "";
  private orderNumberSearched = new BehaviorSubject<string>("");
  orderNumberSearched$ = this.orderNumberSearched.asObservable();

  private orders = new BehaviorSubject<Order[]>([]);
  orders$ = this.orders.asObservable();

  captchaToken: string = "";

  constructor(
    private http: HttpClient,
    private _authService: AuthService,
    private _apiHomologationService: ApiHomologationService,
    private _myAccountService: MyAccountService,
    private _notificationService: NotificationService,
    private _orderProductDetailService: OrderProductDetailService
  ) {

  }

  getWaybillStatus(externalOrderNumber: string | null = "", email: string | null = "", pageSize: number = apiConfiguration.pageSize, offset: number = 0): Observable<ApiResponse> {
    let url = ""
    if (this._myAccountService.isAutenticated()) {
      url = `${environment.url}/v1/order-status-web-all?pageSize=${pageSize}&offset=${offset}`;
    } else {
      url = `${environment.url}/v1/order-status-web?pageSize=${pageSize}&offset=${offset}`;
    }

    if (externalOrderNumber != null && externalOrderNumber != undefined && externalOrderNumber != "") url = url + "&externalOrderNumber=" + externalOrderNumber;
    if (this._myAccountService.getEmail() != null && this._myAccountService.getEmail() != undefined && this._myAccountService.getEmail() != "") url = url + "&email=" + this._myAccountService.getEmail();

    if (this.captchaToken != "") {
      url = url + "&token=" + this.captchaToken;
    }
    //url = "assets/mocks/order-waybill-mock.json"
    return this.http.get<ApiResponse>(url);
  }

  getProductImageBySku(sku: string): Observable<any> {
    const ENDPOINT = `/v1/products/image/${sku}`;
    const URL = `${environment.url}${ENDPOINT}`;
    return this.http.get(URL);
  }

  setOrderNumber(orderNumber: string) {
    this.orderNumber = orderNumber;
    this.orderNumberSearched.next(orderNumber);
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (this.orderNumber != null) {
        sessionStorage.setItem('orderNumber', this.orderNumber);
      }
    }
  }

  getOrderNumber() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (this.orderNumber != null) {
        const orderNumerSaved = sessionStorage.getItem('orderNumber');
        if (orderNumerSaved != null && orderNumerSaved != undefined) {
          this.orderNumber = orderNumerSaved;
        }
      }
    }
    if (this.orderNumberSearched.value == "") this.orderNumberSearched.next(this.orderNumber);
    return this.orderNumber;
  }

  setOrders(apiResponse: ApiResponse) {

    try {
      if (apiResponse.data.data) {
        let data = apiResponse.data.data;

        if (data) {
          /* data = data.sort((a, b) => a.lineSequenceNumber - b.lineSequenceNumber); */
          const ordersNew: Order[] = [];

          if (data != null) {
            const dataFiltered = ApiHomologationService.associateServicesWithProducts(data);
            let id = 0;

            const imageRequests = dataFiltered.map(x => {
              id++;
              x.id = id;

              return this.getProductImageBySku(x.sku).pipe(
                map((response: any) => {
                  const results = response;
                  if (results) {
                    x.imageSku = results.base64;
                    x.descSKU = ApiHomologationService.capitalizeFirstLetter(x.descSKU)! + " - " + x.sku;
                    if (results.name != null && results.name != "null" && results.name != "") {
                      x.descSKU = results.name;
                    }
                  }
                  return x;
                }),
                catchError(error => {
                  console.log(`[${x.sku}] ERROR loading image "${x.sku}"`);
                  return of(x);
                })
              );
            });

            const deliveredDate = dataFiltered.map(x => {
              if (x.tentativeDeliveryDate == null) {
                return this._orderProductDetailService.getEstimatedDelivery(x.salesDocument).pipe(
                  map((response: any) => {
                    if (response) {
                      x.tentativeDeliveryDate = `${ApiHomologationService.formatDate(response.minimumDateHDFormatted)} A ${ApiHomologationService.formatDate(response.maximumDateHDFormatted)} `;
                    }
                    return x;
                  }),
                  catchError(error => {
                    console.log(`[${x.sku}] ERROR loading additional data "${x.sku}"`);
                    return of(x);
                  })
                );
              } else {
                x.tentativeDeliveryDate = ApiHomologationService.formatDate(x.tentativeDeliveryDate);
                return of(x);
              }
            });


            forkJoin({
              images: forkJoin(imageRequests),
              updatedData: forkJoin(deliveredDate)
            }).subscribe(({ images, updatedData }) => {
              updatedData.forEach(x => {
                x.quantity = x.quantity == undefined || x.quantity == null ? 1 : x.quantity;
                let uniqueTrackingNumbers: string[] = [];

                if (x.historyStatus) {
                  const trackingLatestDates = new Map<string, number>();
                  x.historyStatus.forEach(item => {
                    if (item.trackingNumber && item.trackingNumber.trim() !== '') {
                      const time = item.historyDate ? new Date(item.historyDate).getTime() : 0;
                      const existingTime = trackingLatestDates.get(item.trackingNumber) || 0;
                      if (time >= existingTime) {
                        trackingLatestDates.set(item.trackingNumber, time);
                      }
                    }
                  });

                  let allTrackings = Array.from(trackingLatestDates.keys())
                    .sort((a, b) => (trackingLatestDates.get(b) || 0) - (trackingLatestDates.get(a) || 0));

                  const validTrackings = allTrackings.filter(t => !t.includes('-.') && !t.endsWith('-'));
                  uniqueTrackingNumbers = validTrackings.length > 0 ? validTrackings : allTrackings;
                }

                for (var i = 0; i < x.quantity; i++) {
                  let trackingNumber = null;
                  if (uniqueTrackingNumbers.length > 1) {
                    if (uniqueTrackingNumbers[i] != undefined) {
                      trackingNumber = uniqueTrackingNumbers[i];
                    } else {
                      trackingNumber = "NN";
                    }
                  } else if (uniqueTrackingNumbers.length === 1 && x.quantity === 1) {
                    trackingNumber = uniqueTrackingNumbers[0];
                  }
                  ordersNew.push(ApiHomologationService.mapToOrder(x, trackingNumber!));
                }
              });

              this.orders.next(ordersNew);
              //console.log(ordersNew);

              if (typeof window !== 'undefined' && window.sessionStorage) {
                sessionStorage.removeItem("orderData");
                sessionStorage.setItem("orderData", JSON.stringify(ordersNew));
              }
            });
          }
        } else {
          if (typeof window !== 'undefined' && window.sessionStorage) {
            sessionStorage.setItem("orderData", JSON.stringify([]));
          }
        }
      }
    } catch (error) {
      console.error('Error al cargar los datos:', error);
      this._notificationService.showError('Ocurrió un error al cargar los datos.');
    }

  }

  getOrders() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const storedData = sessionStorage.getItem('orderData');
      if (storedData) {
        this.orders.next(JSON.parse(storedData));
      }
    }
    return this.orders;
  }



}
